const cards = [
  {
    title: '剑尊归来',
    genre: '热血 / 武侠',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20cover%20illustration%20of%20a%20powerful%20martial%20arts%20master%20holding%20a%20gleaming%20sword%20against%20a%20dramatic%20sunset%20sky%20with%20cherry%20blossoms%20falling%2C%20dynamic%20action%20pose%20with%20flowing%20robes%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20clean%20minimal%20background%20with%20soft%20gradient%2C%20modern%20digital%20illustration%20style%20with%20bold%20lineart%2C%20perfect%20for%20a%20comic%20reading%20platform%20thumbnail&width=600&height=800&seq=card-manga-01&orientation=portrait',
  },
  {
    title: '我独自升级',
    genre: '奇幻 / 冒险',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20manga%20cover%20illustration%20of%20a%20lone%20hunter%20standing%20before%20a%20mysterious%20glowing%20portal%20in%20a%20dark%20dungeon%2C%20surrounded%20by%20floating%20magical%20runes%20and%20shadowy%20figures%2C%20cool%20blue%20and%20purple%20color%20scheme%20with%20neon%20accents%2C%20clean%20minimal%20composition%2C%20modern%20digital%20art%20style%20with%20sharp%20contrast%2C%20perfect%20for%20a%20comic%20reading%20platform%20thumbnail&width=600&height=800&seq=card-manga-02&orientation=portrait',
  },
  {
    title: '女神降临',
    genre: '恋爱 / 校园',
    status: '已完结',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20cover%20illustration%20of%20a%20stylish%20young%20woman%20with%20long%20flowing%20hair%20smiling%20gently%20in%20a%20school%20uniform%2C%20surrounded%20by%20soft%20floating%20flower%20petals%20and%20sparkles%2C%20warm%20pink%20and%20peach%20color%20palette%2C%20clean%20minimal%20background%20with%20soft%20bokeh%20effect%2C%20romantic%20shojo%20manga%20art%20style%20with%20delicate%20lines%2C%20perfect%20for%20a%20comic%20reading%20platform%20thumbnail&width=600&height=800&seq=card-manga-03&orientation=portrait',
  },
  {
    title: '暗黑之城',
    genre: '悬疑 / 奇幻',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manga%20cover%20illustration%20of%20a%20shadowy%20figure%20walking%20through%20a%20foggy%20urban%20alleyway%20at%20night%20with%20dim%20streetlights%20casting%20eerie%20glows%2C%20dark%20teal%20and%20charcoal%20color%20scheme%20with%20amber%20accent%20lights%2C%20atmospheric%20thriller%20vibe%2C%20clean%20minimal%20composition%2C%20modern%20digital%20illustration%20style%20with%20moody%20lighting%2C%20perfect%20for%20a%20comic%20reading%20platform%20thumbnail&width=600&height=800&seq=card-manga-04&orientation=portrait',
  },
  {
    title: '斗破苍穹',
    genre: '玄幻 / 热血',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20grand%20manga%20cover%20illustration%20of%20a%20young%20cultivator%20surrounded%20by%20swirling%20flames%20and%20ancient%20Chinese%20dragon%20spirits%20in%20a%20mountainous%20landscape%2C%20vibrant%20orange%20and%20gold%20color%20palette%20with%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20clean%20minimal%20composition%2C%20modern%20Chinese%20manhua%20art%20style%20with%20dynamic%20energy%20effects%2C%20perfect%20for%20a%20comic%20reading%20platform%20thumbnail&width=600&height=800&seq=card-manga-05&orientation=portrait',
  },
  {
    title: '全职猎人',
    genre: '冒险 / 热血',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20cover%20illustration%20of%20a%20determined%20young%20adventurer%20with%20spiky%20hair%20holding%20a%20fishing%20rod%20like%20weapon%20in%20a%20lush%20green%20forest%2C%20adventure%20spirit%20vibe%2C%20bright%20green%20and%20earthy%20color%20palette%2C%20clean%20minimal%20composition%2C%20classic%20shonen%20manga%20art%20style%20with%20bold%20outlines%2C%20perfect%20for%20a%20comic%20reading%20platform%20thumbnail&width=600&height=800&seq=card-manga-06&orientation=portrait',
  },
  {
    title: '甜蜜暴击',
    genre: '恋爱 / 日常',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20sweet%20manga%20cover%20illustration%20of%20a%20cheerful%20couple%20sharing%20ice%20cream%20on%20a%20sunny%20park%20bench%20under%20cherry%20blossom%20trees%2C%20surrounded%20by%20floating%20heart%20shapes%2C%20soft%20pastel%20pink%20and%20mint%20color%20palette%2C%20light%20and%20fluffy%20atmosphere%2C%20clean%20minimal%20composition%2C%20modern%20romantic%20comedy%20art%20style%2C%20perfect%20for%20a%20comic%20reading%20platform%20thumbnail&width=600&height=800&seq=card-manga-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            妖精动漫编辑团队为你精选的热门作品，本本都是高分佳作
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href={`#cards`}
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
                <img
                  src={card.imageUrl}
                  alt={`妖精动漫 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                {card.status === '已完结' && (
                  <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-background-50">
                    已完结
                  </span>
                )}
                {card.status === '连载中' && (
                  <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-background-50">
                    连载
                  </span>
                )}
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{card.genre}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}